module.exports = __webpack_public_path__ + "img/sprites-2x.png";